<template>
  <div>
    <el-container>
      <el-aside :width="isCollapse ? '64px' : '200px'" class="aside-with-footer">
        <div class="aside-inner">
          <menu-navigation :collapse="isCollapse"></menu-navigation>
          <div class="aside-footer">深圳市智多杰</div>
        </div>
      </el-aside>
      <el-container class="you_el-container">
        <el-header>
          <div class="header-div">
            <div class="header-left">
              <el-tooltip effect="dark" :content="isCollapse ? '展开导航' : '收起导航'" placement="bottom">
                <el-button type="info" :icon="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" circle @click="toggleCollapse"></el-button>
              </el-tooltip>
              <h1 class="header-title">自助证件照管理系统 V1.0</h1>
            </div>
            <div class="header-right">
              <span class="user-info">{{ realName }}，欢迎登录</span>
              <el-button type="danger" @click="Unlogin()">注销登录<i class="el-icon-right el-icon--right"></i></el-button>
            </div>
          </div>
        </el-header>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import MenuNavigation from '../components/common/menu.vue'

export default {
  components: { MenuNavigation },
  data() {
    return {
      realName: '',
      isCollapse: false
    }
  },
  created() {
    this.loadUserInfo()
    this.loadCollapseSetting()
  },
  methods: {
    loadUserInfo() {
      try {
        const loginInfoStr = sessionStorage.getItem('loginInfo')
        if (loginInfoStr) {
          const loginInfo = JSON.parse(loginInfoStr)
          this.realName = loginInfo.realName || loginInfo.name || '未知用户'
        }
      } catch (e) {
        this.realName = '未知用户'
      }
    },
    loadCollapseSetting() {
      this.isCollapse = localStorage.getItem('menuCollapse') === 'true'
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
      localStorage.setItem('menuCollapse', this.isCollapse.toString())
    },
    Unlogin() {
      sessionStorage['_login'] = 'false'
      sessionStorage.removeItem('loginInfo')
      sessionStorage.removeItem('_token')
      this.$router.push({ path: '/login' })
    }
  }
}
</script>

<style>
.el-header {
  background-color: #D0D0D0;
  color: #333;
  text-align: center;
  line-height: 60px;
  padding: 0 16px;
  overflow: hidden;
}

.el-aside {
  background-color: #2f3e4e;
  color: #333;
  text-align: left;
  height: 100vh;
  transition: width 0.3s;
  overflow: hidden;
}

.aside-with-footer {
  display: flex;
  flex-direction: column;
}

.aside-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.aside-footer {
  margin-top: auto;
  text-align: center;
  color: #ffffff;
  font-size: 12px;
  padding: 10px 5px;
  opacity: 0.8;
}

.you_el-container {
  height: 100vh;
}

.el-main {
  background-color: #FFFFFF;
  color: #000;
  text-align: left;
  line-height: 40px;
}

.el-menu {
  border: none !important;
}

.header-div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  min-width: 0;
  height: 100%;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
}

.header-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 0 0 auto;
  margin-left: auto;
}

.user-info {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
}

@media (max-width: 1200px) {
  .header-title { display: none; }
}
</style>
